import { css, cva } from '@/styled-system/css';

export const autocompleteContainerStyles = css.raw({
  position: 'relative',
  width: '100%',
  float: 'left',
  paddingBottom: '200',
  md: {
    flex: 1,
    marginRight: '400',
    paddingBottom: 0,
  },
});

export const dropdownStyles = css.raw({
  position: 'absolute',
  width: '100%',
  maxWidth: '100vw',
  zIndex: 100,
  maxHeight: '100vh',
  borderRadius: '0 0 {radii.100} {radii.100}',
  marginTop: '-50',
  paddingTop: '50',
  border: '1px solid {colors.border.subtle}',
  borderTop: 'none',
  textAlign: 'left',
});

export const dropDownItemRecipe = cva({
  base: {
    padding: { base: '0 18px', md: '0 {spacing.600}' },
    cursor: 'pointer',
    _lastOfType: {
      borderRadius: '0 0 3px 3px',
      '& > *': {
        borderBottom: 'none',
      },
    },
  },
  variants: {
    isActive: {
      true: {
        background: 'bg.softer',
      },
      false: {
        // oxlint-disable-next-line constellation/no-raw-color-values
        background: 'white',
      },
    },
  },
});

export const dropdownItemTextStyles = css.raw({
  /* must define width in pixels for text truncation */
  width: 'calc(100% - 0px)',
  height: { base: '1200', md: '58px' },
  lineHeight: { base: '46px', md: '1400' },
  borderBottom: '1px solid {colors.border.onImpact.action.neutral.pressed}',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  fontFamily: 'heading',
});
